/**
 * HTML Validation Helper for SWAGDIGI-9254
 * Ensures proper HTML syntax and validation compliance
 */

// Global ID tracker to prevent duplicates
const usedIds = new Set();

/**
 * Generate a guaranteed unique ID
 * @param {string} prefix - ID prefix
 * @returns {string} - Unique ID
 */
export function generateUniqueId(prefix = 'id') {
  let counter = 1;
  let id = `${prefix}-${Date.now()}-${counter}`;
  
  while (usedIds.has(id)) {
    counter++;
    id = `${prefix}-${Date.now()}-${counter}`;
  }
  
  usedIds.add(id);
  return id;
}

/**
 * Check if an element has duplicate attributes (for development/testing)
 * @param {Element} element - DOM element to check
 * @returns {Array} - Array of duplicate attribute names
 */
export function checkDuplicateAttributes(element) {
  const attributes = element.attributes;
  const attrNames = [];
  const duplicates = [];
  
  for (let i = 0; i < attributes.length; i++) {
    const name = attributes[i].name;
    if (attrNames.includes(name)) {
      duplicates.push(name);
    } else {
      attrNames.push(name);
    }
  }
  
  return duplicates;
}

/**
 * Validate HTML syntax in development mode
 * @param {Element} element - Root element to validate
 * @returns {Object} - Validation results
 */
export function validateHtmlSyntax(element = document.body) {
  if (process.env.NODE_ENV !== 'development') {
    return { valid: true, errors: [] };
  }
  
  const errors = [];
  const usedIds = new Set();
  
  // Check for duplicate IDs
  const elementsWithId = element.querySelectorAll('[id]');
  elementsWithId.forEach(el => {
    const id = el.id;
    if (usedIds.has(id)) {
      errors.push(`Duplicate ID found: ${id}`);
    } else {
      usedIds.add(id);
    }
  });
  
  // Check for duplicate attributes on each element
  const allElements = element.querySelectorAll('*');
  allElements.forEach((el, index) => {
    const duplicates = checkDuplicateAttributes(el);
    if (duplicates.length > 0) {
      errors.push(`Element ${index} has duplicate attributes: ${duplicates.join(', ')}`);
    }
  });
  
  return {
    valid: errors.length === 0,
    errors,
    totalElements: allElements.length,
    totalIds: usedIds.size
  };
}

/**
 * Clean up ID tracker (useful for testing)
 */
export function clearIdTracker() {
  usedIds.clear();
}

// Auto-validate in development mode
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const results = validateHtmlSyntax();
      if (!results.valid) {
        //console.warn('🚨 HTML Validation Issues Found (SWAGDIGI-9254):', results.errors);
      } else {
        // console.log('✅ HTML Validation Passed (SWAGDIGI-9254)', {
        //   elements: results.totalElements,
        //   uniqueIds: results.totalIds
        // });
      }
    }, 1000);
  });
}